import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, Link, Text,
} from '@domain-group/suit-theme'

import usePublicationBooking from '@hooks/usePublicationBooking'

import { confirmDelete } from '@functions/entity'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import { PublicationBookingModel } from '@models/types'

interface EditionReleasedProps {
  filteredPublicationBookings: PublicationBookingModel[],
  selectedPublicationBooking: PublicationBookingModel | {},
}

const EditionReleased = (props: EditionReleasedProps) => {
  const { filteredPublicationBookings, selectedPublicationBooking } = props

  const publicationBookingPayload = usePublicationBooking(selectedPublicationBooking)
  const {
    callbacks: {
      unapprovePublicationBooking: unapproveFn,
    },
    publicationBooking: {
      booking_confirmation_id,
    },
    urls: {
      downloadPDFUrl,
    },
  } = publicationBookingPayload

  const selectedBookingIndex = filteredPublicationBookings.findIndex(
    // @ts-expect-error TS2339
    booking => booking.id === selectedPublicationBooking.id,
  )
  const pageNumber = selectedBookingIndex + 1

  const confirmDeletePayload = {
    callbacks: {
      deleteFn: unapproveFn,
    },
    strings: {
      confirmString: 'Are you sure? This will unapprove the page on Realhub but the artwork will still be available to the publication.',
      deleteString: 'Unapprove',
      entityName: 'Booking Page',
    },
  }

  return (
    <Box flexDirection="column" justifyContent="center" alignItems="center">
      <Box flexDirection="column" justifyContent="center" alignItems="center" padding="medium">
        <FontAwesomeIcon icon={faCheck} style={{ color: '#43ac6a', fontSize: '48px', lineHeight: 1 }} />
        <Text color="#43ac6a">All pages released</Text>
      </Box>

      <Box marginTop="large" padding="medium" justifyContent="center">
        <Text fontSize="xsmall">
          Page {pageNumber} - {booking_confirmation_id ? `#${booking_confirmation_id}` : 'No booking confirmation ID'}

          <span> | </span>

          <AuthenticatedDownload>
            <Link href={downloadPDFUrl}>
              Download
            </Link>
          </AuthenticatedDownload>

          <span> | </span>

          {/*
           // @ts-expect-error TS2345 */}
          <Link onClick={() => confirmDelete(confirmDeletePayload)} style={{ tabIndex: 0 }}>
            Unapprove
          </Link>
        </Text>
      </Box>
    </Box>
  )
}

export default EditionReleased
